import { createColorBySettingsStore, type ColorByScope } from '@sl/core/colorBy';
import { browserDemoStorage } from '../../app/api/ApiClientProvider';

// "Reset demo" and "Start fresh" forget the chart's colour settings too (REQ-025 AC8, REQ-001 AC6).
//
// The record lives at `sl.chartColors.<accountId>` — outside the demo namespace, like the tree's expansion
// record (D-097 (7)) and for the same reason: the same adapter serves a live account and "Start fresh" does
// not clear that namespace. So the shell clears it by hand, one call beside `clearExpansionFor`.
//
// BUG-014's lesson, applied before it can happen again: clearing the RECORD is not clearing the CHART. The
// hook reads the record once and holds the answer in React state, so a shell that wipes it underneath would
// leave a heat map on screen until the next reload. This module is the seam — one notification, sent after
// the record is gone, carrying the account it was gone for. A chart on that account returns to Static; a
// chart on another account is untouched.

type ClearedListener = (scope: ColorByScope) => void;

const listeners = new Set<ClearedListener>();

/** Called by `useChartColors`. Returns the unsubscribe, so an unmounted chart hears nothing. */
export function onChartColorsCleared(listener: ClearedListener): () => void {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
}

export async function clearChartColorsFor(scope: ColorByScope): Promise<void> {
  await createColorBySettingsStore(browserDemoStorage(), scope).clear();
  for (const listener of [...listeners]) listener(scope);
}
